import {get, post} from "./request";

export const CategoryApi = {};
CategoryApi.getAll = async () => {
  try {
    const {data} = await post(
      `/category/all`,
      {order: [["id", "ASC"]]},
      {size: 999}
    );
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
CategoryApi.getOne = async (id) => {
  try {
    const {data} = await get(`/category/one/${id}`);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const SectorApi = {};
SectorApi.getAll = async () => {
  try {
    const {data} = await post(
      `/sector/all`,
      {order: [["id", "ASC"]]},
      {size: 999}
    );
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const SubCategoryApi = {};
SubCategoryApi.getAll = async () => {
  try {
    const {data} = await post(
      `/subCategory/all`,
      {order: [["id", "ASC"]]},
      {size: 999}
    );
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
